import { mapActions, mapGetters, mapState } from 'vuex';
import contentLoaderMixin from '@/mixins/contentLoader';
import loaderMixin from '@/mixins/loader';
import shareInviteWidget from '@/components/social/share-invite-widget/share-invite-widget.vue';
import leaderboardsLevels from '@/components/leaderboards/leaderboards-levels/leaderboards-levels.vue';
import leaderboardsTable from '@/components/leaderboards/leaderboards-table/leaderboards-table.vue';
import leaderboardsToolbar from '@/components/leaderboards/leaderboards-toolbar/leaderboards-toolbar.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import headerTagsMixin from '@/mixins/headerTags';

export default {
  mixins: [
    accountVerifyMixin,
    contentLoaderMixin,
    headerTagsMixin,
    loaderMixin,
  ],
  components: {
    leaderboardsLevels,
    leaderboardsTable,
    leaderboardsToolbar,
    shareInviteWidget,
  },
  metaInfo() {
    return {
      title: 'Leaderboards',
      link: [
        { rel: 'canonical', href: `${window.location.href}` },
      ],
      meta: [
        { itemprop: 'image', content: `${window.location.origin}/static/logo.png` },
        { property: 'og:title', content: 'Leaderboards' },
        { property: 'og:type', content: 'article' },
        { property: 'og:image', content: `${window.location.origin}/static/logo.png` },
        { property: 'og:site_name', content: 'Predictit' },
        { property: 'og:url', content: `${window.location.href}` },
      ],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('leaderboards', ['selectedLeaderboard']),
    ...mapState('leaderboards', ['selectedLeaderboardId', 'leaderboardsDateRange']),
  },
  watch: {
    selectedLeaderboardId(value) {
      if (value === null || this.leaderboardsDateRange === null) return;

      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: value,
          dateRange: this.leaderboardsDateRange,
        },
      });
    },
    leaderboardsDateRange(value) {
      if (value === null || this.selectedLeaderboardId === null) return;

      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: this.selectedLeaderboardId,
          dateRange: value,
        },
      });
    },
  },
  methods: {
    ...mapActions('leaderboards', ['clearSelectedLeaderboardId', 'resetLeaderboardsDateRange']),
    onBackClick() {
      this.clearSelectedLeaderboardId();
      this.resetLeaderboardsDateRange();
      this.$router.push({ name: 'leaderboards' });
    },
  },
  created() {
    this.reorganizeTags();
  },
  beforeDestroy() {
    this.clearSelectedLeaderboardId();
    this.resetLeaderboardsDateRange();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-leaderboards/page-leaderboards.js